import { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { BodyText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────

export const NotificationPreferencesTitle = (props: PropsWithChildren) => {
  const { children } = props;

  return (
    <BodyText sizeMatch={['16']} bold style={styles.text}>
      {children}
    </BodyText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  text: {
    marginBottom: theme.spacing['1'],
  },
});
